export default function makeEchoProxy(workerPort) {
  // Single map for all listeners
  const listeners = new Map();

  // Centralized message handler
  workerPort.onmessage = ({ data }) => {
    const key = `${data.ch}:${data.ev}`;
    if (listeners.has(key)) {
      listeners.get(key).forEach(cb => cb(data.p));
    }
  };

  // Core listen implementation
  function addListener(channel, event, cb) {
    const key = `${channel}:${event}`;
    if (!listeners.has(key)) {
      listeners.set(key, new Set());
      workerPort.postMessage({ type: 'subscribe', channel, event });
    }
    listeners.get(key).add(cb);
  }

  // The single proxy object we’ll return
  const proxy = {
    listen(channel, event, cb) {
      addListener(channel, event, cb);
      return proxy;
    },
    private(name) { return wrap(`private:${name}`); },
    channel(name) { return wrap(name); },
    join(name) { return wrap(`presence:${name}`); },
    leave(name) { workerPort.postMessage({ type: 'leave', channel: name }); }
  };

  // Wrap helper reuses the same proxy
  function wrap(channel) {
    return {
      listen: (ev, cb) => { addListener(channel, ev, cb); return wrap(channel); },
      here: cb => wrap(channel).listen('here', cb),
      joining: cb => wrap(channel).listen('joining', cb),
      leaving: cb => wrap(channel).listen('leaving', cb),
      error: cb => wrap(channel).listen('error', cb),
    };
  }

  return proxy;
}
